import React, { useState } from "react";
import { Container, Box, TextField, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { backendUrl } from "../utils/urlHelper";

const LoginPage = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const resetPassword = async (e) => {
    e.preventDefault();

    if (!mobileNumber || !oldPassword || !newPassword) {
      setError("Please provide all details");
      return;
    }

    if (oldPassword === newPassword) {
      setError("Current and new password cannot be same");
      return;
    }

    try {
      const response = await axios.post(
        backendUrl + "/api/auth/reset-password",
        {
          username: mobileNumber,
          oldPassword: oldPassword,
          newPassword: newPassword,
        }
      );

      navigate("/login?resetPassword=success");
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Passwrod Reset Failed. Please try again."
      );
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          width: "100%",
          padding: 3,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "white",
        }}
      >
        <Typography
          className="text-blue-900"
          variant="h5"
          sx={{ textAlign: "center", mb: 3, mt: 1 }}
        >
          {" "}
          Change Password
        </Typography>
        {error && (
          <Typography sx={{ my: 1 }} color="error">
            {error}
          </Typography>
        )}
        <TextField
          label="Mobile Number"
          type="tel"
          variant="outlined"
          fullWidth
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          sx={{ marginBottom: 2 }}
        />
        <TextField
          label="Current Password"
          type="password"
          variant="outlined"
          fullWidth
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
          sx={{ marginBottom: 3 }}
        />
        <TextField
          label="New Password"
          type="password"
          variant="outlined"
          fullWidth
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          sx={{ marginBottom: 3 }}
        />
        <Button
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#3B82F6", // Tailwind blue-500 equivalent
            color: "white",
            padding: "0.75rem",
            fontWeight: "bold",
            fontSize: "1rem",
          }}
          onClick={resetPassword}
        >
          Update Password
        </Button>

        <Button
          variant="outlined"
          fullWidth
          onClick={() => navigate("/login")}
          sx={{
            marginTop: 2,
            backgroundColor: "#eeeeee",
            textTransform: "none",
            border: "none",
            fontSize: "1rem",
            padding: "0.75rem",
          }}
        >
          Back to Login
        </Button>
      </Box>
    </Container>
  );
};

export default LoginPage;
